// extracted by mini-css-extract-plugin
export default {"addNewWebIntegration":"UploadNewIntegration_addNewWebIntegration__SoLOu","webIntegrationUploader":"UploadNewIntegration_webIntegrationUploader__ZfvLY"};